/* global store */

export const visibilityChanged = visiblePercentage => store.dispatch({ type: 'VISIBILITY_CHANGE', visiblePercentage });

export const setScrollerScreenHeight = scrollerScreenHeight => store.dispatch({ type: 'SET_SCROLLER_SCREEN_HEIGHT', scrollerScreenHeight });

export const startAd = () => store.dispatch({ type: 'AD_STARTED' });



// WEBPACK FOOTER //
// ./app/javascript/renderer/actions/adActions.js